import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

const PlaceInfo = ({ city }) => {
    return (
        <Grid>
            <Row center="md">
                <Col xs={0} sm={0} md={2}></Col>
                <Col xs={10} sm={6} md={4}>
                    <h3>País: { (city && city.country) ? city.country : "-" }</h3>
                </Col>
                <Col xs={10} sm={6} md={4}>
                    <h3>Provincia: { (city && city.province) ? city.province : "-" }</h3>
                </Col>
                <Col xs={0} sm={0} md={2}></Col>
            </Row>
            <Row center="md">
                <Col xs={0} sm={0} md={2}></Col>
                <Col xs={10} sm={6} md={4}>
                    <h3>Ciudad: { (city && city.name) ? city.name : "-" }</h3>
                </Col>
                <Col xs={10} sm={6} md={4}>
                    <h3>Código postal: { (city && city.postalCode) ? city.postalCode : "-" }</h3>
                </Col>
                <Col xs={0} sm={0} md={2}></Col>
            </Row>
        </Grid>
    );
};

PlaceInfo.propTypes = {
    city: PropTypes.object,
};

export default PlaceInfo;